import { render } from "./Cta2.vue?vue&type=template&id=3ba6f24c"
import script from "./Cta2.vue?vue&type=script&lang=js"
export * from "./Cta2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__